export class IcommonUser {
  CustomerEmail?: string;
  KeyUID?: string;
  // t1?:string;
  // t2?:string;
  UserID?: string = '';
  countryPreference?: string = '';
}



// WEBPACK FOOTER //
// ./src/app/models/user/icommonuserinterFace.ts